module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(!_vm.viewHandle) ? _c('div', {
    staticClass: "d-flex mb-5 justify-center"
  }, [_c('div', [_c('v-text-field', {
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "prefix": "@",
      "label": "Enter Handle",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeHandle(_vm.handle, 0)
      }
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Post Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('post')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedPostAnalysis && _vm.selectedPostAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openPostAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedPostAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedPostTableHeaders,
      "search": _vm.filter,
      "items": _vm.postAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedPostTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.shares === 0 ? '-' : item.shares) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.views === 0 ? '-' : item.views) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate) + " %\n            ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' ? '-' : item.engagement_rate_reach + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n            ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null || item.median_engagement_rate === 0 ? '-' : item.avg_likes)) + "\n          ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null || item.median_engagement_rate === 0 ? '-' : item.avg_comments)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null || item.median_engagement_rate === 0 ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedPostAnalysis),
      callback: function($$v) {
        _vm.selectedPostAnalysis = $$v
      },
      expression: "selectedPostAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.contents),
      expression: "postColStatuses.contents"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.live_date),
      expression: "postColStatuses.live_date"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.url),
      expression: "postColStatuses.url"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.outreach),
      expression: "postColStatuses.outreach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalOutreach') === 0 ? '-' : _vm.calPostTotal('totalOutreach'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.reach),
      expression: "postColStatuses.reach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalReach') === 0 ? '-' : _vm.calPostTotal('totalReach'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.impressions),
      expression: "postColStatuses.impressions"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalImpressions') === 0 ? '-' : _vm.calPostTotal('totalImpressions'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.likes),
      expression: "postColStatuses.likes"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalLikes') === 0 ? '-' : _vm.calPostTotal('totalLikes'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.shares),
      expression: "postColStatuses.shares"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalShares') === 0 ? '-' : _vm.calPostTotal('totalShares'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.comments),
      expression: "postColStatuses.comments"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalComments') === 0 ? '-' : _vm.calPostTotal('totalComments'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.saved),
      expression: "postColStatuses.saved"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalSaved') === 0 ? '-' : _vm.calPostTotal('totalSaved'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.interactions),
      expression: "postColStatuses.interactions"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalInteractions') === 0 ? '-' : _vm.calPostTotal('totalInteractions'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.views),
      expression: "postColStatuses.views"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalViews') === 0 ? '-' : _vm.calPostTotal('totalViews'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.new_engagement_rate),
      expression: "postColStatuses.new_engagement_rate"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRate') === 0 ? '-' : _vm.calPostTotal('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.new_engagement_rate_view),
      expression: "postColStatuses.new_engagement_rate_view"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRateView') === 0 ? '-' : _vm.calPostTotal('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.engagement_rate_reach),
      expression: "postColStatuses.engagement_rate_reach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRateReach') === 0 || _vm.calPostTotal('totalEngagementRateReach') == 'Infinity' ? '-' : _vm.calPostTotal('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.engagement_rate_sd),
      expression: "postColStatuses.engagement_rate_sd"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalEngRateSd') === 0 ? '-' : _vm.calPostTotal('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.median_engagement_rate),
      expression: "postColStatuses.median_engagement_rate"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalMedianEngRate') === 0 ? '-' : _vm.calPostTotal('totalMedianEngRate')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_likes),
      expression: "postColStatuses.avg_likes"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgLikes') === 0 ? '-' : _vm.calPostTotal('totalAvgLikes')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_comments),
      expression: "postColStatuses.avg_comments"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgComments') === 0 ? '-' : _vm.calPostTotal('totalAvgComments')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_views),
      expression: "postColStatuses.avg_views"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgViews') === 0 ? '-' : _vm.calPostTotal('totalAvgViews')))])])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Story Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('story')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedStoryAnalysis && _vm.selectedStoryAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openStoryAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedStoryAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedStoryTableHeaders,
      "search": _vm.filter,
      "items": _vm.storyAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedStoryTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.replies",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.replies === 0 ? '-' : item.replies)) + "\n          ")]
      }
    }, {
      key: "item.link_clicks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.link_clicks === 0 ? '-' : item.link_clicks)) + "\n          ")]
      }
    }, {
      key: "item.sticker_taps",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.sticker_taps === 0 ? '-' : item.sticker_taps)) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.reach === 0 ? '-' : item.reach)) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.impressions === 0 ? '-' : item.impressions)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedStoryAnalysis),
      callback: function($$v) {
        _vm.selectedStoryAnalysis = $$v
      },
      expression: "selectedStoryAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.storyColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalOutreach') === 0 ? '-' : _vm.calStoryTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalReach') === 0 ? '-' : _vm.calStoryTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalImpressions') === 0 ? '-' : _vm.calStoryTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.replies) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalReplies') === 0 ? '-' : _vm.calStoryTotal('totalReplies'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalShares') === 0 ? '-' : _vm.calStoryTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.link_clicks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalLinkClicks') === 0 ? '-' : _vm.calStoryTotal('totalLinkClicks'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.sticker_taps) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalStickerTaps') === 0 ? '-' : _vm.calStoryTotal('totalStickerTaps'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalInteractions') === 0 ? '-' : _vm.calStoryTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalAvgViews') === 0 ? '-' : _vm.calStoryTotal('totalAvgViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.avg_reels_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalAvgReelPlays') === 0 ? '-' : _vm.calStoryTotal('totalAvgReelPlays'))))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Reel Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('reel')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedReelAnalysis && _vm.selectedReelAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openReelAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedReelAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedReelTableHeaders,
      "search": _vm.filter,
      "items": _vm.reelAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedReelTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.shares === 0 ? '-' : item.shares) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.views === 0 ? '-' : item.views) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.plays === 0 ? '-' : _vm.showReelPlayTime(item.plays)) + "\n          ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate === 0 ? '-' : item.new_engagement_rate + '%') + "\n            ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n            ")])]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.interaction_rate_plays === 0 || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' || !item.engagement_rate_reach ? '-' : item.engagement_rate_reach + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n            ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null || !item.avg_likes ? '-' : item.avg_likes)) + "\n          ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null || !item.avg_comments ? '-' : item.avg_comments)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null || !item.avg_views ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null || !item.avg_reels_plays ? '-' : item.avg_reels_plays)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedReelAnalysis),
      callback: function($$v) {
        _vm.selectedReelAnalysis = $$v
      },
      expression: "selectedReelAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.reelColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalOutreach') === 0 ? '-' : _vm.calReelTotal('totalOutreach'))))])]), _vm._v(" "), (_vm.reelColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalReach') === 0 ? '-' : _vm.calReelTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalImpressions') === 0 ? '-' : _vm.calReelTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalLikes') === 0 ? '-' : _vm.calReelTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalShares') === 0 ? '-' : _vm.calReelTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalComments') === 0 ? '-' : _vm.calReelTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.saved) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalSaved') === 0 ? '-' : _vm.calReelTotal('totalSaved'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalInteractions') === 0 ? '-' : _vm.calReelTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalViews') === 0 ? '-' : _vm.calReelTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalPlayTime))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.watches) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalReelWatchTime))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRate') === 0 ? '-' : _vm.calReelTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRateView') === 0 ? '-' : _vm.calReelTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.interaction_rate_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalInteractionRatePlays') === 0 ? '-' : _vm.calReelTotal('totalInteractionRatePlays') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.engagement_rate_reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRateReach') === 0 ? '-' : _vm.calReelTotal('totalEngagementRateReach') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngRateSd') === 0 ? '-' : _vm.calReelTotal('totalEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalMedianEngRate') === 0 ? '-' : _vm.calReelTotal('totalMedianEngRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgLikes') === 0 ? '-' : _vm.calReelTotal('totalAvgLikes')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgComments') === 0 ? '-' : _vm.calReelTotal('totalAvgComments')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgViews') === 0 ? '-' : _vm.calReelTotal('totalAvgViews')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_reels_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalReelPlays') === 0 ? '-' : _vm.calReelTotal('totalReelPlays')))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("TikTok Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('tiktok')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedTikTokAnalysis && _vm.selectedTikTokAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openTikTokAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedTikTokAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedTikTokTableHeaders,
      "search": _vm.filter,
      "items": _vm.tiktokAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedTikTokTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.plays === 0 ? '-' : _vm.showTikTokPlayTime(item.plays)) + "\n          ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate === null || !item.new_engagement_rate ? '-' : item.new_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate_view === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n          ")]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.interaction_rate_plays === null || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%') + "\n          ")]
      }
    }, {
      key: "item.eng_rate_total_viewers",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.eng_rate_total_viewers === null || !item.eng_rate_total_viewers ? '-' : item.eng_rate_total_viewers + '%') + "\n          ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.engagement_rate_sd === null || !item.eng_rate_total_viewers ? '-' : item.engagement_rate_sd + '%') + "\n          ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || !item.eng_rate_total_viewers ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.watchedFullVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watchedFullVideo === null ? '-' : item.watchedFullVideo + '%') + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedTikTokAnalysis),
      callback: function($$v) {
        _vm.selectedTikTokAnalysis = $$v
      },
      expression: "selectedTikTokAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.tiktokColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalOutreach') === 0 ? '-' : _vm.calTikTokTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalTikTokPlayTime))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.watches) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalWatches') === '0s' ? '-' : _vm.calTikTokTotal('totalWatches')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalLikes') === 0 ? '-' : _vm.calTikTokTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalComments') === 0 ? '-' : _vm.calTikTokTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalShares') === 0 ? '-' : _vm.calTikTokTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.saved) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalBookmarks') === 0 ? '-' : _vm.calTikTokTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalInteractions') === 0 ? '-' : _vm.calTikTokTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalViews') === 0 ? '-' : _vm.calTikTokTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalReach') === 0 ? '-' : _vm.calTikTokTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalImpressions') === 0 ? '-' : _vm.calTikTokTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgViews') === 0 ? '-' : _vm.calTikTokTotal('totalAvgViews')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgLikes') === 0 ? '-' : _vm.calTikTokTotal('totalAvgLikes')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgComments') === 0 ? '-' : _vm.calTikTokTotal('totalAvgComments')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_saves) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgSaves') === 0 ? '-' : _vm.calTikTokTotal('totalAvgSaves')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgShares') === 0 ? '-' : _vm.calTikTokTotal('totalAvgShares')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngagementRate') === 0 ? '-' : _vm.calTikTokTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngagementRateView') === 0 || !_vm.calTikTokTotal('totalEngagementRateView') ? '-' : _vm.calTikTokTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.interaction_rate_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalInteractionRatePlays') === 0 || !_vm.calTikTokTotal('totalInteractionRatePlays') ? '-' : _vm.calTikTokTotal('totalInteractionRatePlays') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.eng_rate_total_viewers) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngRateTotalViewers') === 0 ? '-' : _vm.calTikTokTotal('totalEngRateTotalViewers') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngRateSd') === 0 || !_vm.calTikTokTotal('totalEngRateSd') ? '-' : _vm.calTikTokTotal('totalEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalMedianEngRateSd') === 0 ? '-' : _vm.calTikTokTotal('totalMedianEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.watchedFullVideo) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalWatchedFullVideo') === 0 ? '-' : _vm.calTikTokTotal('totalWatchedFullVideo') + '%'))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Youtube Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('youtube')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedYoutubeAnalysis && _vm.selectedYoutubeAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openYoutubeAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedYoutubeAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedYoutubeTableHeaders,
      "search": _vm.filter,
      "items": _vm.youtubeAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedYoutubeTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate_view === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n          ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.engagement_rate_sd === null || !item.new_engagement_rate_view ? '-' : item.engagement_rate_sd + '%') + "\n          ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || !item.new_engagement_rate_view ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedYoutubeAnalysis),
      callback: function($$v) {
        _vm.selectedYoutubeAnalysis = $$v
      },
      expression: "selectedYoutubeAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.youtubeColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalOutreach') === 0 ? '-' : _vm.calYoutubeTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalViews') === 0 ? '-' : _vm.calYoutubeTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalLikes') === 0 ? '-' : _vm.calYoutubeTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalComments') === 0 ? '-' : _vm.calYoutubeTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalInteractions') === 0 ? '-' : _vm.calYoutubeTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgViews') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgLikes') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgComments') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRate') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRateView') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRateSd') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalMedianEngagementRate') === 0 ? '-' : _vm.calYoutubeTotal('totalMedianEngagementRate') + '%'))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("XHS Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('xhs')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedXhsAnalysis && _vm.selectedXhsAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXhsAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedXhsAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedXHSTableHeaders,
      "search": _vm.filter,
      "items": _vm.xhsAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedXHSTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n          ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedXhsAnalysis),
      callback: function($$v) {
        _vm.selectedXhsAnalysis = $$v
      },
      expression: "selectedXhsAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.xhsColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalOutreach') === 0 ? '-' : _vm.calXHSTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.like_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalLikes') === 0 ? '-' : _vm.calXHSTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.comment_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalComments') === 0 ? '-' : _vm.calXHSTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalViews') === 0 ? '-' : _vm.calXHSTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalShares') === 0 ? '-' : _vm.calXHSTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.bookmarks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalBookmarks') === 0 ? '-' : _vm.calXHSTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalInteractions') === 0 ? '-' : _vm.calXHSTotal('totalInteractions'))))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Facebook Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('facebook')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedFbAnalysis && _vm.selectedFbAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openFbAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedFbAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedFbTableHeaders,
      "search": _vm.filter,
      "items": _vm.fbAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedFbTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n          ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedFbAnalysis),
      callback: function($$v) {
        _vm.selectedFbAnalysis = $$v
      },
      expression: "selectedFbAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.fbColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalOutreach') === 0 ? '-' : _vm.calFbTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.like_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalLikes') === 0 ? '-' : _vm.calFbTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.comment_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalComments') === 0 ? '-' : _vm.calFbTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalViews') === 0 ? '-' : _vm.calFbTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalShares') === 0 ? '-' : _vm.calFbTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.bookmarks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalBookmarks') === 0 ? '-' : _vm.calFbTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalInteractions') === 0 ? '-' : _vm.calFbTotal('totalInteractions'))))])]) : _vm._e()])])], 2)], 1)])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": _vm.getUpdateColTitle(),
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgPostAnalysisDialog),
      callback: function($$v) {
        _vm.avgPostAnalysisDialog = $$v
      },
      expression: "avgPostAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Post Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedPostAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalOutreach') === 0 ? '-' : _vm.calPostAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalReach') === 0 ? '-' : _vm.calPostAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalImpressions') === 0 ? '-' : _vm.calPostAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalLikes') === 0 ? '-' : _vm.calPostAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalShares') === 0 ? '-' : _vm.calPostAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalComments') === 0 ? '-' : _vm.calPostAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalSaved') === 0 ? '-' : _vm.calPostAvg('totalSaved'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalInteractions') === 0 ? '-' : _vm.calPostAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalViews') === 0 ? '-' : _vm.calPostAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRate') === 0 ? '-' : _vm.calPostAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRateView') === 0 ? '-' : _vm.calPostAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Reach")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRateReach') === 0 || _vm.calPostAvg('totalEngagementRateReach') == 'Infinity' ? '-' : _vm.calPostAvg('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Avg. Engagement Rate")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngRateSd') === 0 ? '-' : _vm.calPostAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalMedianEngRate') === 0 ? '-' : _vm.calPostAvg('totalMedianEngRate')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgLikes') === 0 ? '-' : _vm.calPostAvg('totalAvgLikes')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgComments') === 0 ? '-' : _vm.calPostAvg('totalAvgComments')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgViews') === 0 ? '-' : _vm.calPostAvg('totalAvgViews')))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgPostAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgStoryAnalysisDialog),
      callback: function($$v) {
        _vm.avgStoryAnalysisDialog = $$v
      },
      expression: "avgStoryAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Story Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedStoryAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalOutreach') === 0 ? '-' : _vm.calStoryAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalReach') === 0 ? '-' : _vm.calStoryAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalImpressions') === 0 ? '-' : _vm.calStoryAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalReplies') === 0 ? '-' : _vm.calStoryAvg('totalReplies'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalShares') === 0 ? '-' : _vm.calStoryAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalShares') === 0 ? '-' : _vm.calStoryAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Links Click:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalLinkClicks') === 0 ? '-' : _vm.calStoryAvg('totalLinkClicks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalStickerTaps') === 0 ? '-' : _vm.calStoryAvg('totalStickerTaps'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalInteractions') === 0 ? '-' : _vm.calStoryAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalAvgViews') === 0 ? '-' : _vm.calStoryAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Reels Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalAvgReelPlays') === 0 ? '-' : _vm.calStoryAvg('totalAvgReelPlays'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgStoryAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgReelAnalysisDialog),
      callback: function($$v) {
        _vm.avgReelAnalysisDialog = $$v
      },
      expression: "avgReelAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Reel Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedReelAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalOutreach') === 0 ? '-' : _vm.calReelAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalReach') === 0 ? '-' : _vm.calReelAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalImpressions') === 0 ? '-' : _vm.calReelAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalLikes') === 0 ? '-' : _vm.calReelAvg('totalReplies'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalShares') === 0 ? '-' : _vm.calReelAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalComments') === 0 ? '-' : _vm.calReelAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalSaved') === 0 ? '-' : _vm.calReelAvg('totalSaved'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalInteractions') === 0 ? '-' : _vm.calReelAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalViews') === 0 ? '-' : _vm.calReelAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalAvgPlayTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalAvgReelWatchTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRate') === 0 ? '-' : _vm.calReelAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRateView') === 0 ? '-' : _vm.calReelAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalInteractionRatePlays') === 0 ? '-' : _vm.calReelAvg('totalInteractionRatePlays') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Reach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRateReach') === 0 ? '-' : _vm.calReelAvg('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Avg. Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngRateSd') === 0 ? '-' : _vm.calReelAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalMedianEngRate') === 0 ? '-' : _vm.calReelAvg('totalMedianEngRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgLikes') === 0 ? '-' : _vm.calReelAvg('totalAvgLikes')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgComments') === 0 ? '-' : _vm.calReelAvg('totalAvgComments')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgViews') === 0 ? '-' : _vm.calReelAvg('totalAvgViews')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Reels Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalReelPlays') === 0 ? '-' : _vm.calReelAvg('totalReelPlays')))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgReelAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgTiktokAnalysisDialog),
      callback: function($$v) {
        _vm.avgTiktokAnalysisDialog = $$v
      },
      expression: "avgTiktokAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average TikTok Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedTikTokAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalOutreach') === 0 ? '-' : _vm.calReelAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.avgTikTokPlayTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalWatches') === '0s' ? '-' : _vm.calTikTokAvg('totalWatches')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalLikes') === 0 ? '-' : _vm.calTikTokAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalComments') === 0 ? '-' : _vm.calTikTokAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalShares') === 0 ? '-' : _vm.calTikTokAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Favourites:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalBookmarks') === 0 ? '-' : _vm.calTikTokAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalInteractions') === 0 ? '-' : _vm.calTikTokAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalViews') === 0 ? '-' : _vm.calTikTokAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Viewers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalReach') === 0 ? '-' : _vm.calTikTokAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalImpressions') === 0 ? '-' : _vm.calTikTokAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgViews') === 0 ? '-' : _vm.calTikTokAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgLikes') === 0 ? '-' : _vm.calTikTokAvg('totalAvgLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgComments') === 0 ? '-' : _vm.calTikTokAvg('totalAvgComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgSaves') === 0 ? '-' : _vm.calTikTokAvg('totalAvgSaves'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgShares') === 0 ? '-' : _vm.calTikTokAvg('totalAvgShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngagementRate') === 0 ? '-' : _vm.calTikTokAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngagementRateView') === 0 ? '-' : _vm.calTikTokAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalInteractionRatePlays') === 0 ? '-' : _vm.calTikTokAvg('totalInteractionRatePlays') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Total Viewers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngRateTotalViewers') === 0 ? '-' : _vm.calTikTokAvg('totalEngRateTotalViewers') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngRateSd') === 0 ? '-' : _vm.calTikTokAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalMedianEngRateSd') === 0 ? '-' : _vm.calTikTokAvg('totalMedianEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Watched Full Video:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalWatchedFullVideo') === 0 ? '-' : _vm.calTikTokAvg('totalWatchedFullVideo') + '%'))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgTiktokAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgYoutubeAnalysisDialog),
      callback: function($$v) {
        _vm.avgYoutubeAnalysisDialog = $$v
      },
      expression: "avgYoutubeAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Youtube Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedYoutubeAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalOutreach') === 0 ? '-' : _vm.calYoutubeAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalViews') === 0 ? '-' : _vm.calYoutubeAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalLikes') === 0 ? '-' : _vm.calYoutubeAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalComments') === 0 ? '-' : _vm.calYoutubeAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalInteractions') === 0 ? '-' : _vm.calYoutubeAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgViews') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgLikes') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgComments') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRate') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRateView') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRateSd') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalMedianEngagementRate') === 0 ? '-' : _vm.calYoutubeAvg('totalMedianEngagementRate') + '%'))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgYoutubeAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgXhsAnalysisDialog),
      callback: function($$v) {
        _vm.avgXhsAnalysisDialog = $$v
      },
      expression: "avgXhsAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average XHS Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedXhsAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalOutreach') === 0 ? '-' : _vm.calXhsAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalLikes') === 0 ? '-' : _vm.calXhsAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalComments') === 0 ? '-' : _vm.calXhsAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalViews') === 0 ? '-' : _vm.calXhsAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalShares') === 0 ? '-' : _vm.calXhsAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Bookmarks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalBookmarks') === 0 ? '-' : _vm.calXhsAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalInteractions') === 0 ? '-' : _vm.calXhsAvg('totalInteractions'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgXhsAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgFbAnalysisDialog),
      callback: function($$v) {
        _vm.avgFbAnalysisDialog = $$v
      },
      expression: "avgFbAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Facebook Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedFbAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalOutreach') === 0 ? '-' : _vm.calFbAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalLikes') === 0 ? '-' : _vm.calFbAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalComments') === 0 ? '-' : _vm.calFbAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalViews') === 0 ? '-' : _vm.calFbAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalShares') === 0 ? '-' : _vm.calFbAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Bookmarks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalBookmarks') === 0 ? '-' : _vm.calFbAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalInteractions') === 0 ? '-' : _vm.calFbAvg('totalInteractions'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgFbAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0974dec0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/StatisticsAnalysis/DataTable.vue
// module id = 1992
// module chunks = 0